import { useCMSPageField } from '@/cms/fields'
import { CatalogueType } from '@/config/types'
import { useIntl } from '@/intl'
import { Drawer } from '@/scopes/common/components/Drawer'
import { PublicationCodes } from '@/scopes/common/domain/models'
import { useConfiguration } from '@/scopes/common/infrastructure/config/ConfigProvider'
import { useDestinationActions } from '@/scopes/destinations/infrastructure/depedencies/dependencies'
import cn from 'classnames'
import * as React from 'react'
import DestinationDropdown from '../../DestinationSelector/DestinationDropdown'
import styles from './DestinationSelector.module.css'

const placeHolderTranslationTagByCatalogue: Record<CatalogueType, string> = {
  summer: 'destinations_page_placeholder_item_country__summer',
  winter: 'destinations_page_placeholder_item_country__winter',
}

export default function DestinationSelector() {
  const intl = useIntl()
  const { destinationSelected } = useDestinationActions()
  const countries = useCMSPageField('DestinationsPage.countries')
  const publicationCode = useConfiguration('publicationCode')
  const season = PublicationCodes.isSunwebWinterPublicationCode(publicationCode) ? 'winter' : 'summer'

  const optionChangeHandler = (value?: string) => {
    destinationSelected({ url: value })
  }

  return (
    <Drawer className={cn(styles.drawer)}>
      <Drawer.Items className={styles.items}>
        <DestinationDropdown
          key="country-destination"
          id="country-destination"
          placeholder={intl.formatMessage({ id: placeHolderTranslationTagByCatalogue[season] })}
          options={countries.map(country => ({ name: country.title, url: country.link, isSelected: false }))}
          label={intl.formatMessage({ id: 'destination_dropdown_label_country' })}
          handleChange={optionChangeHandler}
        />
      </Drawer.Items>
    </Drawer>
  )
}
